import React from "react";
import { Box, Typography } from "@mui/material";
import IosShareIcon from "@mui/icons-material/IosShare";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";

import CustomModal from "../CustomModal";
import CustomButton from "../CustomButton";
import { setCustomModal } from "../../../redux/features/settingSlice";
import { useDispatch } from "react-redux";

const HomeScreenModal = () => {
  const dispatch = useDispatch();
  return (
    <Box>
      <CustomModal subject={"Azad"}>
        <Box>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "18px",
              lineHeight: "28px",
              mb: "18px",
            }}
          >
            Add Azad to your home screen
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              mb: "30px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <IosShareIcon sx={{ mr: "4px", color: "gray.main" }} />
              <Typography
                sx={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  pt: "6px",
                  color: "gray.main",
                }}
              >
                Press the
                <Typography
                  component='span'
                  sx={{
                    fontWeight: 600,
                    mx: "3px",
                    color: "gray.main",
                  }}
                >
                  share
                </Typography>
                button in the bottom bar
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mt: "12px" }}>
              <AddBoxOutlinedIcon sx={{ mr: "4px", color: "gray.main" }} />
              <Typography
                sx={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  pt: "6px",
                  color: "gray.main",
                }}
              >
                Select the
                <Typography
                  component='span'
                  sx={{
                    fontWeight: 600,
                    mx: "3px",
                    color: "gray.main",
                  }}
                >
                  Add to Home Screen
                </Typography>
                option
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: "12px",
                mb: "32px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  pt: "6px",
                  color: "gray.main",
                  fontWeight: 600,
                }}
              >
                Add{" "}
                <Typography
                  component='span'
                  sx={{
                    mx: "3px",
                    color: "gray.main",
                  }}
                >
                  At the top,{" "}
                </Typography>
                select Add{" "}
              </Typography>
            </Box>
            <CustomButton
              title='Got it'
              onClick={() => dispatch(setCustomModal(false))}
              fSize='20px'
              width='100%'
              height='48px'
              bShadow='2px'
              bgColor='primary.main'
            />
          </Box>
        </Box>
      </CustomModal>
    </Box>
  );
};
export default HomeScreenModal;
